export const GLOW_CONTOURS = ['linear', 'smooth', 'ring'] as const;
export const GLOSS_CONTOURS = ['linear', 'rounded', 'ring'] as const;

type EffectContour = 'linear' | 'smooth' | 'rounded' | 'ring';

// Built-in paint response curves, separate from the calibrated bevel surface
// contour. Zero stays neutral; opacity is applied after shaping the response.
export function effectContourTable(profile: EffectContour, opacity = 1) {
  return Array.from({ length: 257 }, (_, index) => {
    const t = index / 256;
    const response =
      profile === 'smooth'
        ? t * t * (3 - 2 * t)
        : profile === 'rounded'
        ? Math.sin((Math.PI * t) / 2)
        : profile === 'ring'
        ? index === 256
          ? 0
          : Math.sin(Math.PI * t) ** 2
        : t;
    return response * opacity;
  }).join(' ');
}
